module.exports = __webpack_public_path__ + "img/appBg-links--card.55d3ca65.svg";